"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SecondCurrentStep = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const atome_1 = require("../../../components/atome");
const atome_2 = require("../../../components/atome");
const GlobalStyles_1 = require("../../../helper/GlobalStyles");
const Dashboard_style_1 = require("./Dashboard.style");
const SecondCurrentStep = (props) => {
    const { userInformation, monthNames } = props;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_native_1.View, { style: Dashboard_style_1.styles.mobileCurrentHeader },
            react_1.default.createElement(atome_2.Text, { style: [
                    Dashboard_style_1.styles.heading3,
                    GlobalStyles_1.globalStyles.width100,
                    GlobalStyles_1.globalStyles.marginTop15,
                ] }, "Ihr pers\u00F6nliches Erstgespr\u00E4ch")),
        react_1.default.createElement(react_native_1.View, { style: [
                GlobalStyles_1.globalStyles.row,
                Dashboard_style_1.styles.appointmentContainer,
                Dashboard_style_1.styles.mobileCalendar,
                GlobalStyles_1.globalStyles.alignCenter,
            ] },
            react_1.default.createElement(react_native_1.View, { style: [GlobalStyles_1.globalStyles.marginLeft25] },
                react_1.default.createElement(atome_1.Icon, { icon: 'calendar', size: 60 }),
                react_1.default.createElement(atome_2.Text, { style: [
                        Dashboard_style_1.styles.text,
                        GlobalStyles_1.globalStyles.textBold,
                        GlobalStyles_1.globalStyles.positionAbsolute,
                        Dashboard_style_1.styles.heading2,
                        Dashboard_style_1.styles.appointmentDay,
                    ] }, new Date(userInformation.appointment[0].startDate)
                    .getDate()
                    .toLocaleString('de-DE', {
                    minimumIntegerDigits: 2,
                }))),
            react_1.default.createElement(react_native_1.View, { style: [
                    GlobalStyles_1.globalStyles.flex2,
                    GlobalStyles_1.globalStyles.marginLeft25,
                ] },
                react_1.default.createElement(atome_2.Text, { style: [Dashboard_style_1.styles.containerText] }, "Ihr Termin:"),
                react_1.default.createElement(atome_2.Text, { style: [Dashboard_style_1.styles.containerHeader] }, new Date(userInformation.appointment[0].startDate)
                    .getDate()
                    .toLocaleString('de-DE', {
                    minimumIntegerDigits: 2,
                }) +
                    '. ' +
                    monthNames[new Date(userInformation.appointment[0].startDate).getMonth()] +
                    ' ' +
                    new Date(userInformation.appointment[0].startDate).getFullYear()),
                react_1.default.createElement(atome_2.Text, { style: [Dashboard_style_1.styles.containerHeader] }, 'um ' +
                    new Date(userInformation?.appointment[0].startDate)
                        .toLocaleTimeString('de-DE')
                        .slice(0, -3) +
                    ' Uhr'))),
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_native_1.View, { style: Dashboard_style_1.styles.mobileDivider }),
            react_1.default.createElement(react_native_1.View, { style: Dashboard_style_1.styles.mobileAppointment },
                react_1.default.createElement(react_native_1.View, { style: Dashboard_style_1.styles.mobileAdresse },
                    react_1.default.createElement(atome_2.Text, { style: [
                            Dashboard_style_1.styles.OfflineAppointmentContainerText,
                        ] },
                        "Ort:",
                        ' '),
                    react_1.default.createElement(react_native_1.View, { style: [GlobalStyles_1.globalStyles.marginLeft25] },
                        react_1.default.createElement(atome_2.Text, { style: [
                                Dashboard_style_1.styles.addresseText,
                                GlobalStyles_1.globalStyles.paddingRight5,
                            ] }, userInformation.appointment[0].practice
                            ? userInformation.appointment[0].practice
                                .name
                            : 'Online'),
                        react_1.default.createElement(atome_2.Text, { style: [
                                Dashboard_style_1.styles.addresseText,
                                GlobalStyles_1.globalStyles.paddingRight5,
                            ] }, userInformation.appointment[0].practice &&
                            userInformation.appointment[0].practice
                                .address[0].street +
                                ' ' +
                                userInformation.appointment[0].practice
                                    .address[0].houseNumber),
                        react_1.default.createElement(atome_2.Text, { style: [
                                Dashboard_style_1.styles.addresseText,
                                GlobalStyles_1.globalStyles.paddingRight5,
                            ] }, userInformation.appointment[0].practice &&
                            userInformation.appointment[0].practice
                                .address[0].postcode +
                                ' ' +
                                userInformation.appointment[0].practice
                                    .address[0].city))),
                react_1.default.createElement(react_native_1.View, { style: [
                        Dashboard_style_1.styles.mobileAdresse,
                        GlobalStyles_1.globalStyles.marginTop25,
                    ] },
                    react_1.default.createElement(atome_2.Text, { style: [
                            Dashboard_style_1.styles.OfflineAppointmentContainerText,
                        ] }, "Arzt:"),
                    react_1.default.createElement(react_native_1.View, { style: [GlobalStyles_1.globalStyles.marginLeft25] },
                        react_1.default.createElement(atome_2.Text, { style: [Dashboard_style_1.styles.addresseText] },
                            userInformation.appointment[0].doctorTitle,
                            ' ',
                            userInformation.appointment[0].doctorName)))))));
};
exports.SecondCurrentStep = SecondCurrentStep;
